<template>
    <!--企业门店详情-->
  <div class="store">
    <div class="store-title">
      {{edit_verify?'新认证信息':'认证信息'}}
      <span class="edit_status" v-if="!edit_verify"><i class="icon-shimingrenzheng iconfont"></i>{{storeInfo.edit_status==1 ? '重新认证' : '新用户认证'}}</span>
      <span class="edit_status" v-else>认证原因：{{storeInfo.reason}}</span>
      <!-- <span>{{storeInfo.edit_verify.reason}}</span> -->
    </div>
    <div  class="d-flex flex-wrap flex-padding">
      <div class="d-start-start mb-3 w-100">
        <left-text leftText="企业名称"/>{{storeInfo.title || '无'}}
      </div>
      <div class="d-start-start mb-3 w-50">
         <left-text leftText="统一社会信用码"/>{{storeInfo.unity_code || '无'}}
      </div>
      <div class="d-start-start mb-3 w-50" >
        <template v-if="!edit_verify">
          <left-text leftText="业务对接人"/>{{storeInfo.person_liable_name || '无'}}
        </template>
      </div>
      <div class="d-start-start mb-3 w-50">
        <left-text leftText="营业执照"/>
        <span v-if="!storeInfo.certpic">未上传</span>
        <div class="demo-image__preview" v-else>
          <el-image 
            style="width: 90px; height: 90px"
            :src="ImgPreUrl+storeInfo.certpic|| storeInfo.avatar" 
            >
          </el-image>
        </div>
      </div>
      <div class="d-start-start mb-3 w-50 img-review" v-if="type==2">
        <left-text leftText="经营许可证"/>
        <span v-if="!storeInfo.licence">未上传</span>
        <div class="demo-image__preview" v-else>
          <el-image 
            style="width: 100px; height: 100px"
            :src="ImgPreUrl+storeInfo.licence" 
            >
          </el-image>
        </div>
      </div>
      <template v-if="type==3">
        <div class="d-start-start mb-3 w-50" >
          <left-text leftText="消防验收合格证"/>
          <span v-if="!storeInfo.certfire">未上传</span>
          <div class="demo-image__preview" v-else>
            <el-image 
              style="width: 100px; height: 100px"
              :src="ImgPreUrl+storeInfo.certfire" 
              >
            </el-image>
          </div>
        </div>
        <div class="d-start-start mb-3 w-50" >
          <left-text leftText="卫生许可证"/>
          <span v-if="!storeInfo.certheal">未上传</span>
          <div class="demo-image__preview" v-else>
            <el-image 
              style="width: 100px; height: 100px"
              :src="ImgPreUrl+storeInfo.certheal" 
              >
            </el-image>
          </div>
        </div>
        <div class="d-start-start mb-3 w-50" >
          <left-text leftText="特种行业许可证"/>
          <span v-if="!storeInfo.certspec">未上传</span>
          <div class="demo-image__preview" v-else>
            <el-image 
              style="width: 100px; height: 100px"
              :src="ImgPreUrl+storeInfo.certspec" 
              >
            </el-image>
          </div>
        </div>
      </template>
      <div class="d-start-start mt-3">
        <left-text leftText="省市区"/>
        {{storeInfo.province_name}}{{storeInfo.city_name}}{{storeInfo.district_name}}{{storeInfo.address}}
        <i class="el-icon-location location" v-if="type==3"></i>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AuthInfo',
  components: {},
  props: {
    storeInfo: {
      type: Object,
      default: () => {}
    },
    type: {
      type: Number,
      default: 0
    },
    edit_verify: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
    };
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {},
  methods: {}
};
</script>

<style lang="scss" scoped>
  .store{
    width: 100%;
    background-color: #fff;
    text-align: center;
    border-radius: 6px;
    text-align: left;
    overflow: hidden;  
    box-shadow: 0px 0px 7px #eee;
 }
 .store-title{
    background-color: #f5f7fc;
    width: 100%;
    padding: 18px;
    color: #2e3949;
    font-size: 16px;
    font-weight: bold;
    display: flex;
 }
  .flex-padding{
    padding: 18px;
    align-items: center;
    width: 100%;
 }
  .location{
    font-size: 20px;
    color: var(--smtc-color-primary); 
    margin-left: 6px;
    cursor: pointer;
  }
  .edit_status{
    font-weight:normal;
    font-size: 12px;
    background-color: var(--smtc-color-text-red);
    color: #fff;
    padding: 6px 10px;
    border-radius: 4px;
    margin-top: -3px;
    margin-left: 12px;
    i{
      margin-right: 4px;
      font-size: 14px;
    }
  }  
</style>
